// extracted by mini-css-extract-plugin
export default {"dropdown":"DropdownBox_dropdown__d0Xgw","radioList":"DropdownBox_radioList__99M35"};